module.exports = __webpack_public_path__ + "img/map-page-title.1b101ae7.svg";